import { FilterTypeEnum } from '@modules/filters/enums';

export const filterTypeLabel = {
  [FilterTypeEnum.BuildingUtilization]: 'Office utilization',
  [FilterTypeEnum.FloorUtilization]: 'Floor utilization',
  [FilterTypeEnum.AreaUtilization]: 'Room utilization',
  [FilterTypeEnum.BuildingsComparison]: 'Compare',
  [FilterTypeEnum.NewBuildings]: 'New offices',
};
